import { render } from "./Content.vue?vue&type=template&id=237bd548&scoped=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=237bd548&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-237bd548"

export default script